module.exports = __webpack_public_path__ + "static/media/diktat-2.5513a607.mp3";